import {
  GET_ALL_SCHOOLS,
  GET_SCHOOL,
  GET_ALL_CLNDR_ACTIVITIES,
  GET_ALL_OTHER_ACTIVITIES,
  // For counts
  GET_CIRCULAR_COUNT_FOR_DASHBOARD,
  GET_NOTICE_COUNT_FOR_DASHBOARD,
  GET_TASK_COUNT_FOR_DASHBOARD,
  GET_UPCOMING_EXAM_COUNT_FOR_DASHBOARD,
  GET_UPCOMING_HOLIDAY_COUNT_FOR_DASHBOARD,
  // For data
  GET_UPCOMING_CIRCULAR_FOR_3_DAYS,
  GET_UPCOMING_NOTICE_BOARD_FOR_3_DAYS,
  GET_UPCOMING_EVENT_FOR_MONTH,
  GET_UPCOMING_EXAM_FOR_MONTH,
  GET_UPCOMING_HOLIDAY_FOR_MONTH,
  GET_UPCOMING_MEETING_FOR_WEEK,
  // Fees
  GET_COURSE_FEES,
  GET_DAY_SLOTS,
  GET_TIME_TABLE_EMPLOYEES,
  GET_COURSE_FOR_TIME_TABLE,
  GET_SUBJECT_FOR_TIME_TABLE,
  GET_SUBJECT_TEACHER_CLASS_FOR_TIME_TABLE,
  // Appreciation
  GET_ALL_APPRECIATIONS_TEMPLATES,
  GET_APPREICATION,
  GET_ALL_APPRECIATIONS_ASSIGNS,
  GET_APPRECIATION_CARD,
} from 'actions/admin/schools';

import { FETCH_REPORT, CLOSE_REPORT } from '../../actions/admin/reports';
import { GET_SCHOOL_COURSE_STUDENTS } from '../../actions/admin/students';

const initialState = {
  schoolData: {
    content: [],
  },
  school: {},
  calendarActivities: [],
  otherActivities: [],
  // Report modal
  reportUrl: '',
  isOpenReportModal: false,
  headingName: '',

  courseStudentList: [],
  dashboardData: {
    circularCount: 0,
    noticeboardCount: 0,
    taskCount: 0,
    upcomingExamCount: 0,
    upcomingHolidayCount: 0,
    upcomingCicularForNext3days: [],
    upcomingNoticeboardForNext3days: [],
    upcomingEventForMonth: [],
    upcomingExamForMonth: [],
    upcomingHolidayForMonth: [],
    upcomingMeetingForWeek: [],
  },
  feesList: [],
  // Time table
  daySlots: {},
  timeTableEmployees: [],
  timeTableCourses: [],
  timeTableSubjects: [],
  timeTableSubjectTeacherClass: [],
  // Appreciation
  appreciationTemplates: [],
  appreciationAssigns: [],
  appreciation: {},
  appreciationCard: {},
};

export default function schools(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_SCHOOLS:
      return { ...state, schoolData: action.schoolData };
    case GET_SCHOOL: {
      return { ...state, school: action.school };
    }
    case GET_ALL_CLNDR_ACTIVITIES: {
      return { ...state, calendarActivities: action.cActivities };
    }
    case GET_ALL_OTHER_ACTIVITIES: {
      return { ...state, otherActivities: action.activities };
    }
    case GET_SCHOOL_COURSE_STUDENTS: {
      return { ...state, courseStudentList: action.courseStudents };
    }
    case FETCH_REPORT: {
      return { ...state, isOpenReportModal: true, reportUrl: action?.fileData, headingName: action?.headingName };
    }
    case CLOSE_REPORT: {
      return { ...state, isOpenReportModal: false, reportUrl: '', headingName: '' };
    }
    // Dashboard for counts
    case GET_CIRCULAR_COUNT_FOR_DASHBOARD: {
      return { ...state, dashboardData: { ...state.dashboardData, circularCount: action.circularCount } };
    }
    case GET_NOTICE_COUNT_FOR_DASHBOARD: {
      return { ...state, dashboardData: { ...state.dashboardData, noticeboardCount: action.noticeboardCount } };
    }
    case GET_TASK_COUNT_FOR_DASHBOARD: {
      return { ...state, dashboardData: { ...state.dashboardData, taskCount: action.taskCount } };
    }
    case GET_UPCOMING_EXAM_COUNT_FOR_DASHBOARD: {
      return { ...state, dashboardData: { ...state.dashboardData, upcomingExamCount: action.upcomingExamCount } };
    }
    case GET_UPCOMING_HOLIDAY_COUNT_FOR_DASHBOARD: {
      return {
        ...state,
        dashboardData: { ...state.dashboardData, upcomingHolidayCount: action.upcomingHolidayCount },
      };
    }
    // Dahsboard for data's
    case GET_UPCOMING_CIRCULAR_FOR_3_DAYS: {
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          upcomingCicularForNext3days: action.upcomingCicularForNext3days,
        },
      };
    }
    case GET_UPCOMING_NOTICE_BOARD_FOR_3_DAYS: {
      return {
        ...state,
        dashboardData: {
          ...state.dashboardData,
          upcomingNoticeboardForNext3days: action.upcomingNoticeboardForNext3days,
        },
      };
    }
    case GET_UPCOMING_EVENT_FOR_MONTH: {
      return {
        ...state,
        dashboardData: { ...state.dashboardData, upcomingEventForMonth: action.upcomingEventForMonth },
      };
    }
    case GET_UPCOMING_EXAM_FOR_MONTH: {
      return {
        ...state,
        dashboardData: { ...state.dashboardData, upcomingExamForMonth: action.upcomingExamForMonth },
      };
    }
    case GET_UPCOMING_HOLIDAY_FOR_MONTH: {
      return {
        ...state,
        dashboardData: { ...state.dashboardData, upcomingHolidayForMonth: action.upcomingHolidayForMonth },
      };
    }
    case GET_UPCOMING_MEETING_FOR_WEEK: {
      return {
        ...state,
        dashboardData: { ...state.dashboardData, upcomingMeetingForWeek: action.upcomingMeetingForWeek },
      };
    }
    case GET_COURSE_FEES: {
      return {
        ...state,
        feesList: action.fees,
      };
    }
    // Time table
    case GET_DAY_SLOTS: {
      return {
        ...state,
        daySlots: action.daySlots,
      };
    }
    case GET_TIME_TABLE_EMPLOYEES: {
      return {
        ...state,
        timeTableEmployees: action.timeTableEmployees,
      };
    }
    case GET_COURSE_FOR_TIME_TABLE: {
      return {
        ...state,
        timeTableCourses: action.timeTableCourses,
      };
    }
    case GET_SUBJECT_FOR_TIME_TABLE: {
      return {
        ...state,
        timeTableSubjects: action.timeTableSubjects,
      };
    }
    case GET_SUBJECT_TEACHER_CLASS_FOR_TIME_TABLE: {
      return {
        ...state,
        timeTableSubjectTeacherClass: action.timeTableSubjectTeacherClass,
      };
    }
    // Appreciation
    case GET_ALL_APPRECIATIONS_TEMPLATES: {
      return {
        ...state,
        appreciationTemplates: action.appreciationTemplates,
      };
    }
    case GET_ALL_APPRECIATIONS_ASSIGNS: {
      return {
        ...state,
        appreciationAssigns: action.appreciationAssigns,
      };
    }
    case GET_APPREICATION: {
      return {
        ...state,
        appreciation: action.appreciation,
      };
    }
    case GET_APPRECIATION_CARD: {
      return {
        ...state,
        appreciationCard: action.appreciationCard,
      };
    }
    default:
      return state;
  }
}
